// =============================================================================
// Gallery
// =============================================================================

$('document').ready(() => {
    const handleLinkClick = event => {
        if ($('.gallery__focus').css('display') !== 'none') {
            event.preventDefault();

            const $gallery = $(event.delegateTarget);
            const imgSrc = $(event.target).parent().attr('href');
            const imgAlt = $(event.target).attr('alt');

            $gallery.find('.gallery__focus').attr('href', imgSrc);
            $gallery.find('.gallery__image').attr('src', imgSrc);
            $gallery.find('.gallery__image').attr('alt', imgAlt);
        }
    };

    $('.gallery').on('click', '.gallery__link', handleLinkClick);
});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/Gallery.js